import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChangeLanguageComponent} from './change-language.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ChangeLanguageComponent],
  exports: [ChangeLanguageComponent]
})
export class ChangeLanguageModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/shared/change-language/change-language.module.ts